import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Box, CircularProgress } from '@mui/material';
import { authService } from '../api/auth';
import { removeAuthToken } from '../api/client';

function resolveRedirectPath(from: unknown): string {
    if (typeof from !== 'string' || !from.trim()) {
        return '/dashboard';
    }
    const path = from.trim();
    if (path === '/login' || path.startsWith('/login?')) {
        return '/dashboard';
    }
    return path;
}

/** Guest-only pages (login / device login); authenticated users are sent to the app. */
export const GuestRoute = () => {
    const location = useLocation();
    const hasToken = !!localStorage.getItem('accessToken');

    const { data: user, isLoading, isError } = useQuery({
        queryKey: ['user'],
        queryFn: authService.getMe,
        enabled: hasToken,
        retry: false,
    });

    useEffect(() => {
        if (hasToken && isError) {
            removeAuthToken();
        }
    }, [hasToken, isError]);

    if (!hasToken) {
        return <Outlet />;
    }

    if (isLoading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
                <CircularProgress />
            </Box>
        );
    }

    if (user) {
        const redirectTo = resolveRedirectPath((location.state as { from?: string } | null)?.from);
        return <Navigate to={redirectTo} replace />;
    }

    return <Outlet />;
};
